import React, {useEffect, useMemo} from 'react'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {Link, Outlet, useLocation} from 'react-router-dom'
import {ROUTES} from '../../../../_gori/constants'

const AcceptTermUPicLayout = () => {
  const location = useLocation()

  const isLoginPage = useMemo(
    () => location.pathname === ROUTES.AUTH.LOGIN || location.pathname === ROUTES.AUTH.BASE,
    [location.pathname]
  )

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => document.body.classList.remove('bg-white')
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed accept-term-layout'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/gori/login/gori_bg_rocket_1.webp')})`,
      }}
    >
      <div className='d-flex align-items-center flex-column flex-column-fluid mt-100px'>
        <Link to={isLoginPage ? '/' : 'login'}>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/big-shipbae-logo.png')}
            className='h-60px'
          />
        </Link>

        <Outlet />
      </div>
    </div>
  )
}

export {AcceptTermUPicLayout}
